module.exports = __webpack_public_path__ + "static/kylie-0f6aed283ddcf6248ac6be079e703e55.png";